export default __webpack_public_path__ + "static/media/Node_SQLite_-_adamr.space___Codecademy.8d723844.pdf";